import projectOne from "../assets/project-1.jpg";
import projectTwo from "../assets/project-2.jpg";
import projectThree from "../assets/project-3.jpg";

const projects = {
  1: {
    title: "Settled",
    image: projectOne,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
  2: {
    title: "Defeated",
    image: projectTwo,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
  3: {
    title: "Triumph",
    image: projectThree,
    description: (
      <>
        <p>
          Lorem ipsum dolor sit amet
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
};

export default projects;
